import { useSelector } from 'react-redux';

export default function useRestaurantUuid() {
  const restaurantUuid = useSelector(state => state.login.restaurantUuid);
  return typeof restaurantUuid === 'string' && restaurantUuid !== 'select' ? restaurantUuid : null;
}
